class ProductFilters extends HTMLElement {
  constructor() {
    super();
    this.selectedParts = [];
    this.url = '';
    this.collectionHandle = this.getAttribute('collectionHandle') || '';
    this.collectionUrl = this.getAttribute('collectionUrl') || '';
    this.toggleBtn = this.querySelector('.toggle-filters');
    this.selectedFilters = document.querySelectorAll('input[name^="filter"]:checked').length;
    const countEl = document.getElementById('selected-items-count');
    if (countEl) {
      countEl.innerHTML = this.selectedFilters > 0 ? `(${this.selectedFilters})` : '';
    }
    this.clear = this.querySelector('.collection__filters-clear-js');
    if (this.clear && document.querySelectorAll('.filter-item--active').length > 0) {
      this.clear.classList.remove('hidden');
    }
  }

  connectedCallback() {
    this.filterLinks = this.querySelectorAll('.js-filter-item a');
    this.applyButtons = this.querySelectorAll('.js-collection__filters-apply');
    this.filterContainer = this.querySelector("slide-panel[slidepanelid='toggle-filters']");

    this.initializeToggleListeners();
    this.addClickOutsideListener();

    // Search pages filter by query param through FacetFiltersForm (assets/facets.js) instead.
    if (this.collectionHandle && this.collectionUrl) {
      this.updateSelectedPartsFromUrl();
      this.initializeFilterLinkListeners();
    }
  }

  updateSelectedPartsFromUrl() {
    const urlParts = window.location.pathname.split('/').filter((part) => part !== '');
    const lastPart = urlParts[urlParts.length - 1];

    if (lastPart && lastPart !== this.collectionHandle) {
      this.selectedParts = lastPart.split('+');
    }
  }

  initializeToggleListeners() {
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener('click', () => {
        const button = document.querySelector('.product__filter');
        const value = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', String(!value));

        this.toggleFilter();
      });
    }
    if (window.innerWidth > 1024) {
      this.updatePanelPosition();
      window.addEventListener('scroll', () => this.updatePanelPosition());
    }
  }

  initializeFilterLinkListeners() {
    this.filterLinks.forEach((link) => {
      link.addEventListener('click', (event) => {
        event.preventDefault();
        this.handleFilterLinkClick(link);
      });
    });

    this.applyButtons.forEach((applyButton) => {
      applyButton.addEventListener('click', () => {
        this.applyFilters();
      });
    });
  }

  updatePanelPosition() {
    if (!this.toggleBtn || !this.filterContainer) return;

    const toggleButtonRect = this.toggleBtn.getBoundingClientRect();
    const spacing = 16;

    const topPosition = toggleButtonRect.bottom + spacing;
    const finalTopPosition = Math.max(spacing, topPosition);
    this.filterContainer.style.top = `${finalTopPosition}px`;
  }

  handleFilterLinkClick(link) {
    const linkHandle = link.getAttribute('data-handle');

    if (!linkHandle) return;

    const [filterType] = linkHandle.split('-');

    const isAlreadySelected = link.classList.contains('filter-item--active');

    if (isAlreadySelected) {
      link.classList.remove('filter-item--active');
      link.removeAttribute('aria-current');

      const index = this.selectedParts.indexOf(linkHandle);
      if (index !== -1) {
        this.selectedParts.splice(index, 1);
      }
    } else {
      this.deselectOtherOptions(filterType);

      link.classList.add('filter-item--active');
      link.setAttribute('aria-current', 'true');
      this.selectedParts.push(linkHandle);
    }

    if (document.querySelectorAll('.filter-item--active').length > 0) {
      this.clear?.classList.remove('hidden');
    } else {
      this.clear?.classList.add('hidden');
    }

    document.getElementById('selected-items-count').innerHTML =
      `(${document.querySelectorAll('input[type="checkbox"]:checked').length})`;

    this.updateUrl();
  }

  deselectOtherOptions(filterType) {
    this.filterLinks.forEach((link) => {
      const linkHandle = link.getAttribute('data-handle');
      if (linkHandle && linkHandle.startsWith(filterType) && link.classList.contains('filter-item--active')) {
        link.classList.remove('filter-item--active');
        link.removeAttribute('aria-current');

        const index = this.selectedParts.indexOf(linkHandle);
        if (index !== -1) {
          this.selectedParts.splice(index, 1);
        }
      }
    });
  }

  updateUrl() {
    this.url = `${this.collectionUrl}/${this.selectedParts.join('+')}`;
    window.history.replaceState(null, null, this.url);
  }

  applyFilters() {
    this.url = `${this.collectionUrl}/${this.selectedParts.join('+')}`;
    window.location.href = this.url;
  }

  addClickOutsideListener() {
    document.addEventListener('mousedown', (event) => {
      if (
        this.filterContainer &&
        !this.filterContainer.contains(event.target) &&
        !this.toggleBtn.contains(event.target)
      ) {
        this.closeFilter();
      }
    });
  }

  toggleFilter() {
    const isOpen = this.filterContainer.getAttribute('default-open') === 'true';
    if (isOpen) {
      this.closeFilter();
    } else {
      this.openFilter();
      this.scrollToFilterContainer();
    }
  }

  scrollToFilterContainer() {
    const filterContainerRect = document
      .querySelector('button[slidepanelopen="toggle-filters"]')
      .getBoundingClientRect();
    const windowHeight = window.innerHeight;

    const isContainerVisible = filterContainerRect.top >= 0 && filterContainerRect.bottom <= windowHeight;

    if (!isContainerVisible) {
      window.scrollTo({
        top: filterContainerRect.top + 60,
        behavior: 'smooth',
      });
    }
  }

  openFilter() {
    this.filterContainer.classList.remove('hidden');

    this.filterContainer.setAttribute('default-open', 'true');
    document.body.classList.add('overflow-hidden');
    document.body.classList.add('no-scroll');
    document.querySelector('html').classList.add('overflow-hidden');

    if (window.innerWidth > 1023) {
      requestAnimationFrame(() => {
        this.updatePanelPosition();
      });
    }
  }

  closeFilter() {
    this.filterContainer.setAttribute('default-open', 'false');
    document.body.classList.remove('overflow-hidden');
    document.body.classList.remove('no-scroll');
    document.querySelector('html').classList.remove('overflow-hidden');

    // Re-hidden after the close animation; the `hidden` class is what stops the panel flashing on page load.
    setTimeout(() => {
      if (this.filterContainer.getAttribute('default-open') !== 'true') {
        this.filterContainer.classList.add('hidden');
      }
    }, 300);
  }
}

const init = () => {
  if (!customElements.get('product-filters')) {
    customElements.define('product-filters', ProductFilters);
  }
};

init();
